const createMapById = (items) =>
  items.reduce((accum, item) => {
    const accumCopy = { ...accum };
    accumCopy[item.id] = item;
    return accumCopy;
  }, {});

export default createMapById;
